import joinClasses from "helpers/joinClasses";
import Button from ".";

export function PrimaryButton({ className, children, onClick, ...props }) {
  return (
    <Button
      className={joinClasses(
        " text-black text-[18px] border-b border-third !pb-0 !px-0",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
}
